module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADVSURBVEhL7ZRbDoMgEEVBXV6b2JXapMvzgV7CkJE6iEL84hAC6sjhrV9Db9RDNK58hCorQpUV4Zbs1w8+p2C2BC7LuOD9/bhaHL0lW57dIFLvU0X0P+IPZanTA2JSLgJ/08gDFrPYegzEU+aEIrCThQHjMtoyFUlM+GmUAnIRR5YLGqZ8xG6D3B2d1Di1R9+9bDazanVrX6ZKJQmHC0/PWQjvCJfhlqDDC7CTG71fpctrxgVczEUgFIHLIwvpdKcmM7mnONm7MVUEim79M6qsCA/KlFoBG0BomFPah+0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fish.png
// module id = a/wg
// module chunks = 35